import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ExportService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	exportFormations(year: number, weekNumber: number): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/formations/formations.csv/${year}/${weekNumber}`,
			'exportFormations',
			{
				responseType: 'blob'
			}
		);
	}

	exportMissionPlaces(): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/ecoles/ecoles.csv`,
			'exportMissionPlaces',
			{
				responseType: 'blob'
			}
		);
	}

	exportBeneficiaires(): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/beneficiaires/beneficiaire.csv`,
			'exportBeneficiaires',
			{
				responseType: 'blob'
			}
		);
	}

	exportEmployees(): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/employees/employees.csv`,
			'exportEmployees',
			{
				responseType: 'blob'
			}
		);
	}

	exportSolutionAsXlsx(
		_file: string | undefined,
		solutionId: number
	): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/solution/${solutionId}/xlsx`,
			'exportSolutionAsXlsx',
			{
				responseType: 'blob'
			}
		);
	}

	exportAgendaAsICalendar(
		solutionId: number,
		planningId: number
	): Observable<any> {
		let params = new HttpParams().set('onlyCurrent', true);
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/calendar/icalendar/${solutionId}/${planningId}`,
			'exportAgendaAsICalendar',
			{
				params: params,
				responseType: 'blob'
			}
		);
	}

	exportCalendarAsCsv(
		solutionId: number,
		planningId: number
	): Observable<Blob> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.exportUrl}/calendar/csv/${solutionId}/${planningId}`,
			'exportCalendarAsCsv',
			{
				responseType: 'blob'
			}
		);
	}
}
